import React, { Component } from 'react';
import RouteTitle from 'components/shared/route-title/RouteTitle';
import { Alert, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import './WorkOrderSummary.css';
import {
  deleteTaskRequest,
  finishWorkOrderCreation,
  loadWorkOrderSummaryRequest,
  workOrderConfirmationRequest,
  workOrderConfirmationWithoutPicturesRequest,
} from 'actions/admin/work-orders/creation/work-order-summary';
import TaskSummary from './TaskSummary';
import checkCirclePng from 'images/check-circle.png';
import ConfirmationPanel from 'components/shared/confirmation/ConfirmationPanel';
import {
  getShowSubmitRequestConfirmation,
  getShowWorkOrderCreatedConfirmation,
} from 'selectors/admin/work-orders/creation/work-order-summary';
import {
  getCurrentWorkOrder,
  getSummary,
  getTasks,
} from 'selectors/admin/work-orders/work-orders';
import {
  goToSubContractorsUnionTrades,
  goToTasks,
  goToWorkingHours,
  showWOCancellationModal,
} from 'actions/admin/work-orders/creation/creation';
import CancelWorkOrder from './CancelWorkOrder';
import Button from 'components/shared/button/Button';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import numeral from 'numeral';
import { setNewWOProcessStarted } from 'actions/admin/work-orders/creation/sub-contractors-union-trades';
import { editTask } from 'actions/admin/work-orders/creation/tasks';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import { usersUtil, TYPES } from 'services/utils/users-util';
import Flash from 'react-reveal/Flash';

import {
  removeDocumentRequest,
  uploadDocumentsRequest,
} from 'actions/admin/work-orders/details/details';

import DetailsFilesContainer from 'components/shared/details/DetailsFilesContainer';
import Dropzone from 'react-dropzone';
import uploadPng from 'images/upload.png';
import FilesUploadedViewer from 'components/shared/files/FilesUploadedViewer';

class WorkOrderSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPartialSubmitAnimation: false,
      showTaskConfirmation: false,
      taskId: 0,
      taskNumber: 0,
    };
  }

  componentDidMount() {
    this.props.dispatch(setNewWOProcessStarted(false)); // set process started to false
    this.props.dispatch(
      loadWorkOrderSummaryRequest(this.props.currentWorkOrder.id)
    );
  }

  render() {
    return (
      <div className="work-order-summary">
        <RouteTitle
          titles={[
            'WORK ORDERS',
            'WO #' + this.props.currentWorkOrder.number,
            'Summary - Draft status',
          ]}
        />

        {this.showContent()}

        <CancelWorkOrder />

        <ConfirmationModal
          show={this.state.showTaskConfirmation}
          message={`Are you sure you would like to delete Task #${numeral(
            this.state.taskNumber
          ).format('00')}?`}
          onHide={this.handleTaskDeleteConfirmation}
        />
      </div>
    );
  }

  getContent() {
    return (
      <React.Fragment>
        <Col md={8} className="column">
          <div className="content-container">
            <div className="item-container">
              <div className="item-title">Building Details</div>
              <div className="item-line">
                {this.props.summary.building.location.street_address_1}
                {this.props.summary.building.location.street_address_2 !==
                  null &&
                this.props.summary.building.location.street_address_2 !== ''
                  ? ', ' + this.props.summary.building.location.street_address_2
                  : null}
              </div>
              <div className="item-line">
                {this.props.summary.building.location.city + ', '}
                {this.props.summary.building.location.state + ' '}
                {this.props.summary.building.location.zip}
              </div>
              {this.props.summary.building.name !== '' &&
                this.props.summary.building.name !== null && (
                  <div className="item-line">
                    {this.props.summary.building.name}
                  </div>
                )}
            </div>

            {this.props.summary.tasks.length > 0 ? (
              this.props.summary.tasks
                .slice() // copy task for sorting
                .sort(WorkOrderSummary.sortTasks)
                .map((task, index) => {
                  return (
                    <div key={index} className="item-container">
                      <TaskSummary
                        key={index}
                        task={WorkOrderSummary.convertTask(task)}
                        onTaskDelete={this.handleTaskDelete}
                        onTaskEdit={this.handleTaskEdit}
                      />
                    </div>
                  );
                })
            ) : (
              <div className="item-container">
                <div className="item-title">Tasks</div>
                <div className="item-edit">
                  <Button
                    label="Edit"
                    className="button-gray summary-edit-button"
                    onClick={this.handleTasksEdit}
                  />
                </div>
              </div>
            )}

            <div className="item-container">
              <div className="item-title">Available Working Hours</div>
              {this.props.summary.working_hours.map((element, index) => {
                return (
                  <div key={index} className="item-line">
                    {element}
                  </div>
                );
              })}
              <div className="item-edit">
                <Button
                  label="Edit"
                  className="button-gray summary-edit-button"
                  onClick={this.handleWorkingHoursEdit}
                />
              </div>
            </div>

            <div className="item-container">
              <div className="item-title">
                Preferred or Propietary Subcontractors
              </div>
              {this.props.summary.propietary_sub_contractors.length > 0 ? (
                this.props.summary.propietary_sub_contractors.map(
                  (element, index) => {
                    return (
                      <div key={index} className="item-line">
                        {element.name}
                      </div>
                    );
                  }
                )
              ) : (
                <div className="item-line">None</div>
              )}
              <div className="item-edit">
                <Button
                  label="Edit"
                  className="button-gray summary-edit-button"
                  onClick={this.handleSubContractorsUnionTradesEdit}
                />
              </div>
            </div>

            <div className="item-container">
              <div className="item-title">Union Requirements</div>
              <div className="item-line">
                {this.props.summary.unions.length > 0 ? (
                  this.props.summary.unions.map((element, index, array) => {
                    return (
                      <React.Fragment key={index}>
                        <span key={index}>{element.label}</span>
                        {index < array.length - 1 ? ', ' : null}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <span>None</span>
                )}
              </div>
              <div className="item-edit">
                <Button
                  label="Edit"
                  className="button-gray summary-edit-button"
                  onClick={this.handleSubContractorsUnionTradesEdit}
                />
              </div>
            </div>

            {this.partialSubmitAvailable() && (
              <Flash
                count={2}
                spy={this.state.showPartialSubmitAnimation}
                onReveal={() =>
                  this.setState({ showPartialSubmitAnimation: false })
                }
              >
                <Alert bsStyle="warning" className="submit-alert">
                  If a photo for this WO does not apply, please click{' '}
                  <strong>
                    <span onClick={this.handleSubmitWithoutPictures}>here</span>
                  </strong>{' '}
                  for it to be submitted as is.
                </Alert>
              </Flash>
            )}

            {this.props.currentWorkOrder.documents.length === 0 && (
              <Alert bsStyle="warning" className="submit-alert">
                Documents missing for this Work Order, please review.
              </Alert>
            )}

            <div className="button-container">
              <input
                className="btn button button-orange"
                disabled={!this.submitAvailable()}
                value="Submit"
                type="button"
                onClick={this.handleSubmit}
              />
              <input
                className="btn button button-white"
                value="Cancel Order"
                type="button"
                onClick={this.handleCancelOrder}
              />
            </div>
          </div>
        </Col>

        <Col md={4} className="column">
          <DetailsFilesContainer>
            <div className="h2">Documents</div>
            <div className="body-bold files-title">
              Please drag and drop any file into this area
            </div>
            <div className="dropzone-container">
              <Dropzone
                accept="application/pdf, .doc, .docx, .xls, .xlsx"
                className="files-dropzone"
                onDrop={this.handleDocumentsDrop}
              >
                <img src={uploadPng} alt="remove" />
              </Dropzone>
            </div>

            <div className="files-viewer">
              <FilesUploadedViewer
                documents={this.props.currentWorkOrder.documents}
                showLink={true}
                onDocumentRemove={this.handleDocumentRemove}
              />
            </div>
          </DetailsFilesContainer>
        </Col>
      </React.Fragment>
    );
  }

  static sortTasks(taskA, taskB) {
    if (taskA.number < taskB.number) {
      return -1;
    }
    if (taskA.number > taskB.number) {
      return 1;
    }
    return 0;
  }

  getSubmitRequestConfirmation() {
    return (
      <Col md={8} className="column">
        <div className="content-container">
          <ConfirmationPanel
            className="summary-confirmation-panel"
            image={checkCirclePng}
            firstLine="Request submitted"
            lines={['A request was sent to the admin to submit the WO as is.']}
            buttons={[
              <input
                type="button"
                className="btn button button-orange"
                value="Continue"
                onClick={this.handleSubmitRequestContinue}
              />,
            ]}
          />
        </div>
      </Col>
    );
  }

  getWorkOrderConfirmation() {
    return (
      <Col md={8} className="column">
        <div className="content-container">
          <ConfirmationPanel
            className="summary-confirmation-panel"
            image={checkCirclePng}
            firstLine="Success!"
            lines={[
              'Work Order ' +
                this.props.currentWorkOrder.number +
                ' was created.',
              'A member of the Spackle team will reach out for any additional information or documents.',
            ]}
            buttons={[
              <input
                type="button"
                className="btn button button-orange"
                value="Continue"
                onClick={this.handleWorkOrderConfirmationContinue}
              />,
            ]}
          />
        </div>
      </Col>
    );
  }

  showContent() {
    if (this.props.showSubmitRequestConfirmation) {
      return this.getSubmitRequestConfirmation();
    } else if (this.props.showWorkOrderCreatedConfirmation) {
      return this.getWorkOrderConfirmation();
    } else if (this.props.summary !== null) {
      return this.getContent();
    } else {
      return null;
    }
  }

  static convertTask(task) {
    return {
      id: task.id,
      description: task.description,
      dueDate: task.completion_date,
      floor: task.floor,
      images: task.images.map((element) => {
        return {
          preview: element.image.preview.url,
          url: element.image.url,
        };
      }),
      number: task.number,
      room: task.room,
      trade: task.trade.label,
      name: task.name,
    };
  }

  submitAvailable = () => {
    // Submit is available if at least one task is defined, one working hour is defined
    return (
      this.props.summary.tasks.length > 0 &&
      this.props.summary.working_hours.length > 0
    );
  };

  partialSubmitAvailable = () => {
    // Partial submit is available if at least one task is defined, one working hour is defined and if the user is a client,
    // at least one task has no images
    const userIsClient = usersUtil.hasType(this.props.user, TYPES.CLIENT);

    return (
      this.props.summary.tasks.length > 0 &&
      this.props.summary.working_hours.length > 0 &&
      userIsClient &&
      this.props.summary.tasks.filter((task) => {
        return task.images.length === 0;
      }).length > 0
    );
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.partialSubmitAvailable()) {
      this.setState({
        showPartialSubmitAnimation: true,
      });
    } else {
      this.props.dispatch(
        workOrderConfirmationRequest(this.props.currentWorkOrder.id)
      );
    }
  };

  handleSubmitWithoutPictures = (event) => {
    event.preventDefault();
    this.props.dispatch(
      workOrderConfirmationWithoutPicturesRequest(
        this.props.currentWorkOrder.id
      )
    );
  };

  handleSubmitRequestContinue = (event) => {
    event.preventDefault();
    this.props.dispatch(finishWorkOrderCreation());
  };

  handleWorkOrderConfirmationContinue = (event) => {
    event.preventDefault();
    this.props.dispatch(finishWorkOrderCreation());
  };

  handleCancelOrder = (event) => {
    event.preventDefault();
    this.props.dispatch(showWOCancellationModal());
  };

  handleTaskDelete = (id, taskNumber) => {
    this.setState({
      showTaskConfirmation: true,
      taskId: id,
      taskNumber: taskNumber,
    });
  };

  handleTaskEdit = (taskId) => {
    this.props.dispatch(editTask(taskId, this.props.tasks));
    this.props.dispatch(goToTasks());
  };

  handleTasksEdit = () => {
    this.props.dispatch(goToTasks());
  };

  handleTaskDeleteConfirmation = (response) => {
    if (response) {
      this.props.dispatch(deleteTaskRequest(this.state.taskId));
    }

    this.setState({
      showTaskConfirmation: false,
      taskId: 0,
      taskNumber: 0,
    });
  };

  handleSubContractorsUnionTradesEdit = () => {
    simpleScrollToTop();
    this.props.dispatch(goToSubContractorsUnionTrades());
  };

  handleWorkingHoursEdit = () => {
    simpleScrollToTop();
    this.props.dispatch(goToWorkingHours());
  };

  handleDocumentsDrop = (documents) => {
    this.props.dispatch(
      uploadDocumentsRequest(this.props.currentWorkOrder.id, documents)
    );
  };

  handleDocumentRemove = (documentId) => {
    this.props.dispatch(
      removeDocumentRequest(this.props.currentWorkOrder.id, documentId)
    );
  };
}

export default connect((state) => {
  return {
    currentWorkOrder: getCurrentWorkOrder(state),
    summary: getSummary(state),
    showSubmitRequestConfirmation: getShowSubmitRequestConfirmation(state),
    showWorkOrderCreatedConfirmation: getShowWorkOrderCreatedConfirmation(
      state
    ),
    tasks: getTasks(state),
    user: state.auth.user,
  };
})(WorkOrderSummary);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/creation/WorkOrderSummary.js